/* Gemlikzade — lazy product recommendations for gz-product-grid (related / complementary). */
if (!customElements.get('gz-recommendations')) {
  class GzRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      const load = () => this.load();
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          load();
        }, { rootMargin: '0px 0px 600px 0px' });
        observer.observe(this.closest('.shopify-section') || this);
      } else {
        load();
      }
    }

    load() {
      this.dataset.loaded = 'true';
      const section = this.closest('[data-gz-reco-section]');
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const incoming = html.querySelector('gz-recommendations .gz-rail');
          const rail = this.querySelector('.gz-rail');
          if (!incoming || !rail || !incoming.querySelector('li')) {
            if (section) section.hidden = true;
            return;
          }
          rail.innerHTML = incoming.innerHTML;
          if (section) section.hidden = false;
          rail.dispatchEvent(new Event('scroll'));
          section?.querySelectorAll('[data-gz-reveal]').forEach((el) => el.classList.add('is-revealed'));
        })
        .catch(() => { if (section) section.hidden = true; });
    }
  }
  customElements.define('gz-recommendations', GzRecommendations);
}
